import { MainButton } from 'elements/button/MainButton';
import { SidebarSubsectionHeader } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection/SidebarSubsectionHeader';
import { useDownloadQR } from 'hooks/share/useDownloadQR';
import { EFonts, EShadows } from 'libs/styles/styling';
import { EToastType } from 'libs/types/site/IClient';
import { userMessage } from 'libs/utils/logic/ui/uiLogic';
import { useContext } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ShareModal = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const mapViewLink = `${location.protocol}//${location.host}/map/${ctxEdit.map?.worldMapId}`;
    const iFrameText = `<iframe width="100%" height="500" frameborder="0" title="${ctxEdit.map?.title}" src="${mapViewLink}?iframe=true"></iframe>`;
    const downloadQR = useDownloadQR();

    return (
        <S_ShareModal className={props.className}>
            <S_Inner>
                <SidebarSubsectionHeader
                    title={Localization.SHARE_THE_LINK}
                    icon={{
                        iconPrefix: 'fal',
                        iconName: 'link'
                    }}
                />
                <S_Row>
                    <S_Text>{mapViewLink}</S_Text>
                    <S_MainButton
                        type="primary2"
                        onClick={() => {
                            navigator?.clipboard?.writeText(mapViewLink);
                            userMessage(EToastType.SUCCESS, Localization.LINK_COPIED_CLIPBOARD);
                        }}
                    >
                        {Localization.COPY_URL_ACTION}
                    </S_MainButton>
                </S_Row>
                <S_Line />
                <SidebarSubsectionHeader
                    title={Localization.GENERATE_QR_CODE}
                    icon={{
                        iconPrefix: 'fal',
                        iconName: 'qrcode'
                    }}
                />
                <S_Row>
                    <S_MainButton
                        type="primary2"
                        onClick={() => {
                            downloadQR.download(mapViewLink);
                        }}
                    >
                        {Localization.DOWNLOAD_QR_ACTION}
                    </S_MainButton>
                </S_Row>
                <S_Line />
                <SidebarSubsectionHeader
                    title={Localization.EMBED_ON_YOUR_SITE}
                    icon={{
                        iconPrefix: 'fal',
                        iconName: 'code'
                    }}
                />
                <S_Row>
                    <S_Text>{iFrameText}</S_Text>
                    <S_MainButton
                        type="primary2"
                        onClick={() => {
                            navigator?.clipboard?.writeText(iFrameText);
                            userMessage(EToastType.SUCCESS, Localization.HTML_COPIED_CLIPBOARD);
                        }}
                    >
                        {Localization.COPY_HTML_ACTION}
                    </S_MainButton>
                </S_Row>
                <S_Line />
                <SidebarSubsectionHeader
                    title={Localization.COPY_MAP_ID}
                    icon={{
                        iconPrefix: 'fab',
                        iconName: 'wordpress'
                    }}
                />
                <S_Row>
                    <S_Text>{ctxEdit.map.worldMapId}</S_Text>
                    <S_MainButton
                        type="primary2"
                        onClick={() => {
                            navigator?.clipboard?.writeText(ctxEdit.map.worldMapId);
                            userMessage(EToastType.SUCCESS, Localization.COPY_MAP_ID_CLIPBOARD);
                        }}
                    >
                        {Localization.COPY_MAP_ID_ACTION}
                    </S_MainButton>
                </S_Row>
            </S_Inner>
        </S_ShareModal>
    );
};

const S_ShareModal = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #f8f8f8;
    box-shadow: ${EShadows.STRONG};
    border-radius: 7px;
`;

const S_Inner = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px 10px 20px 10px;
    width: 100%;
    box-sizing: border-box;
`;

const S_Row = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin: 0 15px;
`;

const S_Text = styled.div`
    background: #f3f3f3;
    padding: 10px;
    font-size: 12px;
    font-family: ${EFonts.Regular};
    line-height: 18px;
    width: 100%;
    margin: 0 0 12px 0;
    overflow-wrap: break-word;
`;

const S_MainButton = styled(MainButton)`
    width: fit-content;
    flex-shrink: 0;
`;

const S_Line = styled.div`
    width: 100%;
    height: 1px;
    background: #f2f2f2;
    margin: 15px 0 5px 0;
`;
